<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Dashboard</h3>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-calendar></v-calendar>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      selected_acyear: ""
    };
  },
  created() {
    this.$store.dispatch("academicYear/getAll");
    this.$store.dispatch("incomes/getAll",{type:1});
    this.$store.dispatch("expenses/getAll",{type:0});
    this.$store.dispatch("feepayments/getAll");
  },
  computed: {
    ...mapGetters({
      acyears: "academicYear/ACYEARS",
      errors: "academicYear/ACYEAR_ERROR",
      loading: "academicYear/ACYEAR_LOADING",

      incomes: "incomes/INCOMES",
      expenses: "expenses/EXPENSES",

      feepayments: "feepayments/FEEPAYMENTS",
      ferrors: "feepayments/FEEPAYMENT_ERROR",
    }),

    total_income(){
      var fromJournal = this.incomes.reduce((a,b)=>{
        return a + parseFloat(b['amount']);
      },0)

      var fromFeesPayments = this.feepayments? this.feepayments.reduce((a,b)=>{
        return a + parseFloat(b.tot_paid);
      },0):0

      //console.log(fromFeesPayments)
      return parseFloat(fromJournal?fromJournal:0)+(fromFeesPayments?fromFeesPayments:0)
    },
     total_expense(){
      return this.expenses.reduce((a,b)=>{
        return a + parseFloat(b['amount']);
      },0)
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/dashboard.vue